import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AutoFocusDirective } from 'src/app/shared/directives/autofocus.directive';

/**
 * provides a search input element
 * which emits an event when the input value changes or is reset to empty string
 * @class SearchFieldComponent
 * @typedef {SearchFieldComponent}
 */
@Component( {
    selector: 'riege-search-field',
    imports: [
        AutoFocusDirective,
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule
    ],
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    standalone: true
} )
export class SearchFieldComponent implements OnChanges {
    /** reactive form input element */
    searchInput = new FormControl( '' );

    /** initial search */
    @Input() searchTerm: string = '';

    /**
     * event emitter
     * which is triggered when the input changes
     * or reset button is clicked
     *
     * example of one way data binding:
     * `(searchChanged)="applyFilter($event)"``
     * @readonly
     * @type {*}
     */
    @Output() readonly searchChanged = new EventEmitter();

    ngOnChanges(): void {
        if ( this.searchTerm !== '' && this.searchTerm !== undefined ) {
            this.searchInput.setValue( this.searchTerm, { emitEvent: true } );
        }
    }
}
